/**
 * UranIA PA — `/privacy` (informativa sul trattamento dei dati personali).
 *
 * Pagina istituzionale nuova (Riordino della mappa delle rotte §3/§4/§7,
 * Rilascio A passo A.7). Stesso principio di `accessibilita.tsx`: rotta
 * con guscio e struttura, nessun testo legale inventato — placeholder
 * esplicito in attesa dell'informativa del Titolare del trattamento.
 */

import { useTranslation } from 'react-i18next';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { InstitutionalPageShell, PendingNotice } from '../features/sistema/InstitutionalPageShell.tsx';
import { Route as PubblicoRoute } from './_pubblico.tsx';

function PrivacyPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <InstitutionalPageShell
      badge={t('istituzionale.privacy.badge')}
      title={t('istituzionale.privacy.title')}
      testId="privacy-page"
    >
      <PendingNotice body={t('istituzionale.privacy.pending_body')} />
    </InstitutionalPageShell>
  );
}

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/privacy',
  component: PrivacyPage,
});
